import { render, staticRenderFns } from "./fee-management.vue?vue&type=template&id=34fd39b8&scoped=true&"
import script from "./fee-management.vue?vue&type=script&lang=js&"
export * from "./fee-management.vue?vue&type=script&lang=js&"
import style0 from "./fee-management.vue?vue&type=style&index=0&id=34fd39b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34fd39b8",
  null
  
)

export default component.exports